import React, { useState, useEffect } from "react";
import Select from "react-select";
import { Row, Col, FormGroup, Label } from "reactstrap";

import { GetLanguageString } from "../helper/Components";
import { GetSelectedLanguage } from "../helper/Method";
import { ApiUnit } from "../unit/ApiUnit";
import { encryptStorage } from "../../constants/EncryptStorage";

const SelectUnit = ({
  setValues,
  values,
  unitId = 0,
  isDeleted = false,
  excludeExUnit = true,
  isDisabled = false,
  inlineWithArrows = false,
  filterUnitTypes = null,
  excludeUnitTypes = null,
}) => {
  const loggedInUnitId = parseInt(encryptStorage.getItem("loggedInUnitId"));
  const [unitList, setUnitList] = useState([]);
  if (unitId === 0) unitId = loggedInUnitId;
  const unitTypeName = "null";
  useEffect(() => {
    ApiUnit()
      .getUnitList(
        unitId,
        loggedInUnitId,
        isDeleted,
        unitTypeName,
        excludeExUnit,
      )
      .then((res) => {
        setUnitList(res.data);
      })
      .catch((err) => console.log(err));
  }, [unitId, loggedInUnitId, isDeleted, excludeExUnit]);

  const handleChangeUnits = (record) => {
    if (record !== null) {
      ApiUnit()
        .getUnitList(
          record.value,
          loggedInUnitId,
          isDeleted,
          unitTypeName,
          excludeExUnit,
        )
        .then((res) => {
          setUnitList(res.data);
        })
        .catch((err) => console.log(err));

      setValues({
        ...values,
        unit: record,
      });
    }
  };

  const renderSelect = (unitOptions, selected) => (
    <Select
      isDisabled={isDisabled}
      options={unitOptions}
      value={Object.keys(selected).length ? selected : null}
      className="basic-single ur"
      classNamePrefix="select"
      onChange={handleChangeUnits}
    />
  );

  if (inlineWithArrows) {
    return (
      <div className="d-flex flex-wrap align-items-center m-b-md">
        {unitList.map((record, index) => {
          const unitOptions = [];
          record.unitList.forEach((d) =>
            unitOptions.push({
              value: d.id,
              label: d.name,
              label1: d.unitTypeName,
            }),
          );
          let selected = {};
          if (record.selectedUnit !== null) {
            selected = {
              value: record.selectedUnit.id,
              label: record.selectedUnit.name,
              label1: record.selectedUnit.unitTypeName,
            };
          }
          const isLastIndex = index === unitList.length - 1;

          return (
            <React.Fragment key={index}>
              <div style={{ minWidth: 180, flex: "0 0 auto" }}>
                {renderSelect(unitOptions, selected)}
              </div>
              {isLastIndex ? null : (
                <div
                  className="d-flex align-items-center justify-content-center"
                  style={{ width: 40, height: 38, flex: "0 0 auto" }}
                >
                  {GetSelectedLanguage() === "en" ? (
                    <i className="fa fa-arrow-right fa-lg" />
                  ) : (
                    <i className="fa fa-arrow-left fa-lg" />
                  )}
                </div>
              )}
            </React.Fragment>
          );
        })}
      </div>
    );
  }

  return (
    <>
      <Row>
        {unitList.map((record, index) => {
          const unitOptions = [];
          record.unitList.forEach((d) => {
            const matchesFilter =
              (!filterUnitTypes ||
                index < unitList.length - 1 ||
                filterUnitTypes.includes(d.unitTypeName)) &&
              (!excludeUnitTypes || !excludeUnitTypes.includes(d.unitTypeName));

            if (matchesFilter) {
              unitOptions.push({
                value: d.id,
                label: d.name,
                label1: d.unitTypeName,
              });
            }
          });

          if (unitOptions.length === 0) {
            return null;
          }
          let selected = {};
          let unitName = "";
          if (record.parentUnitName !== null) unitName = record.parentUnitName;
          if (record.selectedUnit !== null) {
            selected = {
              value: record.selectedUnit.id,
              label: record.selectedUnit.name,
              label1: record.selectedUnit.unitTypeName,
            };
          }

          return (
            <Col xl="2" key={index}>
              <FormGroup>
                <Label className="col-form-label">
                  {unitName !== "" ? (
                    <GetLanguageString
                      props="member_select_unit_name"
                      value={unitName}
                    />
                  ) : (
                    <GetLanguageString props="member_select_unit" />
                  )}
                </Label>
                {renderSelect(unitOptions, selected)}
              </FormGroup>
            </Col>
          );
        })}
      </Row>
    </>
  );
};

export default SelectUnit;
